export const getAuthToken = () => {
    return localStorage.getItem('access_token');
};

export const getUserType = () => {
    return localStorage.getItem('userType');
};

export const isAuthenticated = () => {
    const token = getAuthToken();
    const userType = getUserType();
    return !!token && !!userType;
};

export const hasValidRole = (requiredRole) => {
    const userType = getUserType();
    return userType === requiredRole;
};

export const logout = () => {
    try {
        // Clear all persisted state to fully reset session
        localStorage.clear();
        sessionStorage.clear();
    } catch (_) {
        // Fallback in case clear() throws (e.g., storage disabled)
        try { localStorage.removeItem('access_token'); } catch (_) {}
        try { localStorage.removeItem('userType'); } catch (_) {}
    }
    // Redirect to auth page
    window.location.href = '/auth';
};
